import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const MiniPieChart = ({ data, width = 150, height = 120 }) => {
  // Define colors for each category
  const COLORS = {
    'SAT':   '#3B82F6',   // Blue
    'Solar': '#F59E0B',   // Yellow/Amber
    'MTF':   '#10B981',   // Green
    'MTB':   '#06B6D4',   // Teal/Cyan
    'Other': '#6B7280'    // Gray
  };

  // Prepare data for recharts (filter out zero values)
  const chartData = Object.entries(data)
    .filter(([_, value]) => value > 0)
    .map(([name, value]) => ({
      name,
      value: parseFloat(value) || 0,
      color: COLORS[name] || '#6B7280'
    }));

  // If no data, show empty state
  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ width, height }}>
        <p className="text-xs text-gray-500">ไม่มีข้อมูล</p>
      </div>
    );
  }

  // Find the largest segment for center text
  const maxSegment = chartData.reduce((max, item) => 
    item.value > max.value ? item : max, chartData[0]
  );
  
  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  const maxPercentage = ((maxSegment.value / total) * 100).toFixed(0);

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = ((data.value / total) * 100).toFixed(1);
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-2">
          <p className="text-xs font-medium text-gray-900">{data.name}</p>
          <p className="text-xs text-blue-600">
            {parseFloat(data.value).toLocaleString('th-TH', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} บาท
          </p>
          <p className="text-xs text-gray-600">{percentage}%</p>
        </div>
      );
    }
    return null;
  };

  // Don't show labels on chart

  return (
    <div className="relative" style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={20}
            outerRadius={50}
            paddingAngle={2}
            dataKey="value"
            label={false}
            labelLine={false}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      
    </div>
  );
};

export default MiniPieChart;